import { createSlice } from "@reduxjs/toolkit";
import { buyerDashboardCampaignsCount } from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  dashboardCampaigns: null,
  error: null,
};
export const buyerDashboardSlice = createSlice({
  name: "buyerDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(buyerDashboardCampaignsCount.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buyerDashboardCampaignsCount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardCampaigns = action.payload;
      })
      .addCase(buyerDashboardCampaignsCount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default buyerDashboardSlice.reducer;
